import { Component ,  OnInit , Input , AfterViewInit , ViewChild, ViewEncapsulation, HostListener , ChangeDetectorRef , OnDestroy } 	from '@angular/core';
import { Router , RouterModule  , NavigationError, NavigationEnd } 						from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { BoardingService, CommonAdminService } from '@tanzeel/shared';
import { StudentBlockUIService } from '@student/core/blockui/student-blockui.service';
import { StudentMessagingService } from '@student/core/messaging/student-messaging.service';
import { MessageModalComponent } from './core/messaging/messagemodal';
import { TanzeelNotificationComp } from './core/messaging/tanzeel.notification.comp';
import { BlockUIComponent } from './core/blockui/blockui';
import { UiKitModalDialogComp } from './uikit/uikit.modal.dialog';
import { UiKitModalDialogService } from './modal.dialog.service';
declare var gtag: any;
declare var fbq: any;

@Component({
  standalone: false,
  selector: 'my-app',
  templateUrl: "app.component.html",
  styleUrls : [ "../../../../res/css/Ui_kit.css" , "../donationsubscription.css" , "./uikit/uikit.ext.css" , "./app.comp.css" ] ,
  providers : [ 
				RouterModule
			  ],
	encapsulation : ViewEncapsulation.None
})
export class AppComponent implements OnInit , AfterViewInit , OnDestroy {

		page:number =0;
		initialized:boolean = false;
		floatHelpButtonVisible:boolean = true;
		private routerSubscription:Subscription = null;
        tanzeel:any = window["DATA"];
		@ViewChild('messageBox', { static: true }) messageBox: MessageModalComponent;
		@ViewChild('blockUIBox', { static: true }) bksBox: BlockUIComponent;
		@ViewChild(TanzeelNotificationComp) notificationComp?: TanzeelNotificationComp;
		@ViewChild( 'uikitmodalDialog') modalDialogComp:UiKitModalDialogComp;
        contextPath:string = this.tanzeel.contextPath;

		public options:any = {
			position: ["top", "right"],
			timeOut: 5000
		}

        constructor(private router:Router, private mms:StudentMessagingService , private bks:StudentBlockUIService , private commonService:CommonAdminService , private boardingservice:BoardingService , private _modalDialogService:UiKitModalDialogService , private _cdRef:ChangeDetectorRef ){
        }

        ngOnInit(){
            if (new URLSearchParams(window.location.hash.split('?')[1] || '').get('cardRecoveryDisabled') === '1')
                setTimeout(() => this.mms.info('Student account disabled Please contact Support team'));

			this.updateFloatHelpButtonVisibility();
			this.routerSubscription = this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) this.updateFloatHelpButtonVisibility();
				if (event instanceof NavigationError) this.handleNavigationError();
			});
        }

		ngOnDestroy(){
			if( this.routerSubscription != null ){
				this.routerSubscription.unsubscribe();
			}
		}

        private browserRecoveryPending = false;

        private async handleNavigationError(): Promise<void> {
            this.bks.hide();
            if (this.browserRecoveryPending) return;
            this.browserRecoveryPending = true;
            try {
                if (window.confirm("Unable to open this page. Try clearing browser's cache and try again? Please try incognito mode if the error stays.")) {
                    await this.recoverBrowserCache();
                }
            } catch {
                this.mms.showWithTitle('Unable to reload', 'Cache recovery failed. Please check your connection and try again.', false);
            } finally {
                this.browserRecoveryPending = false;
            }
        }

        private async recoverBrowserCache(): Promise<void> {
            const response = await firstValueFrom(this.commonService.clearStudentBrowserCache());
            if (response.status !== 204) throw new Error('Cache recovery failed.');
            await new Promise<void>(resolve => window.setTimeout(resolve, 1000));
            window.location.reload();
        }

        private updateFloatHelpButtonVisibility(){
			const url = this.router.url;
			this.floatHelpButtonVisible = url.indexOf('helpcontact') === -1
				&& url.indexOf('/student/d') === -1;
			this._cdRef.markForCheck();
		}
		
		ngAfterViewInit() {
			if (this.notificationComp != null) {
				this.mms.nts = this.notificationComp;
			}
			if (this.messageBox != null) {
				this.mms.setBox(this.messageBox);
			}
			if (this.bksBox != null) {
				this.bks.setBox(this.bksBox);
			}
			//console.info( " setting modal dialog ")
			this._modalDialogService.modalDialog = this.modalDialogComp;
            // Recovery uses a minimal state endpoint, not normal profile bootstrap.
            if (window.location.hash.startsWith('#/student/r/billing/updateCard')) return;
			var authUser = this.commonService.getLoggedInAuthUser();
			if( authUser != null && authUser.id > 0 )
				this.tanzeel.secureUser = { role : authUser.userRole.roleName };

			if( sessionStorage ){
				var token = this.commonService.getValidJwtToken();
				var tokenFromUrl = sessionStorage.getItem("token_fromurl");
				if( token == null ){
					return;
				}
				var tokenDecode = this.commonService.decodeJwt( token );
				if( tokenDecode['readonly'] && (tokenDecode['readonly']==true || tokenDecode['readonly']=="true") && this.tanzeel.secureUser ){
					this.tanzeel.secureUser['allowEdit'] = false;
				}
				if( token && tokenFromUrl=="true" ){
					sessionStorage.removeItem("token_fromurl" );
					this.boardingservice.navigateAfterAuth(token, this.mms);
				}
			}
		}

/*
	onNetWorkInfo() {
		let nav:any = navigator;
		var connection = nav.connection || nav.mozConnection || nav.webkitConnection;
		connection.addEventListener('change', ()=>{this.onNetWorkInfoChange() });
		this.onNetWorkInfoChange();
	}

	onNetWorkInfoChange() {
		let nav:any = navigator;
		var connection = nav.connection || nav.mozConnection || nav.webkitConnection;

		if( connection ){
			// Network type that browser uses
			console.log('         type: ' + connection.type);

			// Effective bandwidth estimate
			console.log('     downlink: ' + connection.downlink + ' Mb/s');
		
			// Effective round-trip time estimate
			console.log('          rtt: ' + connection.rtt + ' ms');
		
			// Upper bound on the downlink speed of the first network hop
			console.log('  downlinkMax: ' + connection.downlinkMax + ' Mb/s');
		
			// Effective connection type determined using a combination of recently
			// observed rtt and downlink values: ' +
			console.log('effectiveType: ' + connection.effectiveType);
			
			// True if the user has requested a reduced data usage mode from the user
			// agent.
			console.log('     saveData: ' + connection.saveData);
		}
		else {
			console.log('     Connection is null : ' );
		}		
	}
*/

	showhelpContactView(){
		if( sessionStorage ){
			const currentUrl = this.router.url;
			const previousUrl = (currentUrl != null && currentUrl.indexOf('helpcontact') === -1) ? currentUrl : '/boarding/loginUser';
			sessionStorage.setItem( "previousUrlRef" , previousUrl );
		}
		this.router.navigateByUrl("/student/r/helpcontact");
	}
}
